import { render, staticRenderFns } from "./ProcessDocument.vue?vue&type=template&id=61e1300d"
import script from "./ProcessDocument.vue?vue&type=script&lang=js"
export * from "./ProcessDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61e1300d')) {
      api.createRecord('61e1300d', component.options)
    } else {
      api.reload('61e1300d', component.options)
    }
    module.hot.accept("./ProcessDocument.vue?vue&type=template&id=61e1300d", function () {
      api.rerender('61e1300d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/views/customers/view/ProcessDocument.vue"
export default component.exports